// extracted by mini-css-extract-plugin
export var agendaItem = "agenda-item-module--agendaItem--62ced";
export var btns = "agenda-item-module--btns--8d92d";
export var captionVideo = "agenda-item-module--captionVideo--50681";
export var colContent = "agenda-item-module--colContent--4c798";
export var colImage = "agenda-item-module--colImage--7c960";
export var companyLogo = "agenda-item-module--companyLogo--da820";
export var dateBox = "agenda-item-module--dateBox--96aee";
export var horizontal = "agenda-item-module--horizontal--7a71f";
export var job = "agenda-item-module--job--ab754";
export var logoBox = "agenda-item-module--logoBox--6b0ae";
export var multipleAuthors = "agenda-item-module--multipleAuthors--d7ad0";
export var namePerson = "agenda-item-module--namePerson--a4e19";
export var personBlock = "agenda-item-module--personBlock--79693";
export var playVideo = "agenda-item-module--playVideo--31336";
export var square = "agenda-item-module--square--eb6fa";
export var textContent = "agenda-item-module--textContent--cab3e";
export var vertical = "agenda-item-module--vertical--4601a";